export default __webpack_public_path__ + "static/media/gallery_00.a6bc2d40.jpg";